export const FeaturedPress = [
  {
    image: "https://cdn.botfrens.com/assets/home_rareprotocol.jpeg",
    link: "https://twitter.com/rareprotocolbot",
    target: "_self",
    title:
      "SuperRare DAO funds BotFrens to develop Twitter bot for Rare Protocol",
  },
  {
    image: "https://cdn.botfrens.com/assets/news_builder.jpeg",
    link: "https://nouns.build/dao/0xdf9b7d26c8fc806b1ae6273684556761ff02d422/vote/0xee46bb8653d187d2d0266fe9d1bc68cda7bd45c6b8bda59a5b788e5619503d6b",
    target: "_self",
    title:
      "Builder DAO funds BotFrens to continue development of Nounish DAOs bots",
  },
  {
    image: "https://cdn.botfrens.com/assets/news_rarible.png",
    link: "https://daotimes.com/rarible-dao-to-launch-a-twitter-bot-that-displays-real-time-marketplace-info/",
    target: "_blank",
    title:
      "RARI Foundation funds BotFrens to develop Twitter bot for Rarible marketplace",
  },
  {
    image: "https://cdn.botfrens.com/assets/news_foundation.jpg",
    link: "https://twitter.com/Foundation_Bot",
    target: "_blank",
    title:
      "Foundation NFT marketplace partners with BotFrens to launch a Twitter bot",
  },
  {
    image: "https://cdn.botfrens.com/assets/news_nouns.jpg",
    link: "https://nouns.wtf/vote/144",
    target: "_blank",
    title:
      "Nouns DAO funds BotFrens to develop one-click-bots for the Nounish ecosystem",
  },
];

export const FeaturedTeam = [
  {
    avatar: "https://cdn.botfrens.com/assets/team_billy.jpg",
    email: null,
    linkedin: null,
    name: "Billy Shipp",
    title: "Operations",
    twitter: "https://x.com/billyshipp",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/team_charlie.jpg",
    email: null,
    linkedin: null,
    name: "Charlie Shipp",
    title: "Community",
    twitter: "https://x.com/charlie_nws",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/team_cody.jpg",
    email: null,
    linkedin: null,
    name: "Cody Braun",
    title: "Technology",
    twitter: "https://x.com/ItsCodyBraun",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/team_daniel.jpg",
    email: null,
    name: "Daniel Klein",
    title: "Technology",
    twitter: "https://x.com/DanielKleil0308",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/team_francois.jpg",
    email: null,
    name: "François Jaffré",
    title: "Content",
    twitter: null,
    linkedin: "https://www.linkedin.com/in/francois-jaffre/",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/team_julia.jpg",
    email: null,
    name: "Julia Kane",
    title: "Content",
    twitter: null,
  },
];
